import { makeStyles } from '@material-ui/core';

import { pdvColor, pdvRadius } from '../tokens';

export const useStyles = makeStyles({
  scroll: { width: '100%', overflowX: 'auto' },
  head: {
    display: 'grid',
    alignItems: 'center',
    minHeight: 32,
    borderRadius: pdvRadius.s,
    overflow: 'hidden',
    background: pdvColor.surfaceSubtle,
    color: pdvColor.textSecondary,
    fontSize: 12,
    lineHeight: '16px'
  },
  headCell: { display: 'flex', alignItems: 'center', padding: '8px 12px' },
  grid: { display: 'grid', alignItems: 'stretch' },
  cell: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    padding: '8px 12px'
  },
  flush: { padding: 0 },
  left: { justifyContent: 'flex-start', textAlign: 'left' },
  center: { justifyContent: 'center', textAlign: 'center' },
  right: { justifyContent: 'flex-end', textAlign: 'right' },
  clickable: { cursor: 'pointer' },

  /* lined: a rule under every row, hover tints the row */
  linedRow: { borderBottom: `1px solid ${pdvColor.border}` },
  linedGrid: {
    '&$clickable:hover': { background: pdvColor.surfacePage }
  },
  /* The header is the scroller's first div, so data rows start at the second:
     `odd` tints rows 2, 4, … and `even` (cards) tints rows 1, 3, …. */
  striped: {
    '&:nth-of-type(odd) $grid': { background: pdvColor.surfacePage }
  },

  /* cards: rounded rows 8px apart, every other one tinted (Rep Feedback) */
  cardRow: {
    marginTop: 8,
    borderRadius: pdvRadius.m,
    borderBottom: `1px solid ${pdvColor.border}`,
    '&:nth-of-type(even)': { background: pdvColor.surfacePage },
    '&:hover': { background: pdvColor.surfaceSubtle }
  },
  cardCell: { padding: '10px 12px' },

  empty: {
    padding: '24px 12px',
    fontSize: 14,
    textAlign: 'center',
    color: pdvColor.textSecondary
  }
});
